import React from "react";
import "./PrivacyTermsContent.css";

function PrivacyTermsContent({ title, content }) {
  return (
    <div>
      <div id="plan-comparison" className="terms-privacy-container">
        <div className="container">
          <div className="font-semibold text-[24px] md:text-[60px] md:leading-[60px] leading-[28px] py-4 lg:py-8 px-[18px] text-left md:text-center extra-title-heading">
            {title}
          </div>
          <div
            className="leading-[1.4rem] text-[14px] text-justify font-normal text-branded-grey mt-5 md:px-0 px-[18px]"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyTermsContent;
